import type { Shop } from '@prisma/client'

import { getTokens } from './tokens'

const objectToCssString = (obj: Record<string, string>) => {
  return Object.entries(obj)
    .map(([key, value]) => `  ${key}: ${value};`)
    .join('\n')
}

// DO NOT REMOVE THIS COMMENT
// make sure tailwind statically analyzes these and creates classes for them:
// font-sans font-serif font-mono

export const createShopStyleString = (
  shop: Pick<Shop, 'themeColor' | 'themeFont'>
) => {
  if (!shop.themeColor && !shop.themeFont) return ''

  let str = ''

  if (shop.themeFont) {
    if (shop.themeFont === 'serif') {
      str += `
@font-face {
  font-family: 'Noto Serif Variable';
  font-style: normal;
  font-display: swap;
  font-weight: 100 900;
  src: url(https://cdn.jsdelivr.net/fontsource/fonts/noto-serif:vf@latest/latin-wght-normal.woff2) format('woff2-variations');
  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
      `
    }

    if (shop.themeFont === 'mono') {
      str += `
@font-face {
  font-family: 'Geist Mono Variable';
  font-style: normal;
  font-display: swap;
  font-weight: 100 900;
  src: url(https://cdn.jsdelivr.net/fontsource/fonts/geist-mono:vf@latest/latin-wght-normal.woff2) format('woff2-variations');
  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
      `
    }

    str += `
[data-theme|="shop"] {
  --font-shop: var(--font-${shop.themeFont});
}

`
  }

  if (shop.themeColor) {
    const color = shop.themeColor
    const themes = ['light', 'dark', 'overall'] as const
    themes.forEach((mode) => {
      str += `
[data-theme="shop-${mode}"] {
${objectToCssString(getTokens(color, mode))}
}\n`
    })
  }

  return str
}
